import { useCallback, useMemo } from 'react';
import { analytics } from 'app/utils/segment';
import { staticFilterFields, } from '../../../../../../../utils/definitions';
export function useConditionFieldSelect({ condition, onChange, }) {
    const trackValue = useMemo(() => staticFilterFields.includes(condition.field), [condition.field]);
    const handleClear = useCallback(() => {
        analytics.searchFilterValueCleared({
            type: condition.field,
            count: condition.values.length,
        });
        onChange([]);
    }, [condition.field, condition.values.length, onChange]);
    const handleChange = useCallback((item) => {
        const { name: label, id: value } = item;
        const nextValues = [...condition.values];
        const isNew = !condition.values.some(({ value }) => value === item.id);
        if (isNew) {
            const nextValue = { label, value: value.toString() };
            nextValues.push(nextValue);
            analytics.searchFilterValueAdded({
                type: condition.field,
                operator: condition.operator,
                value: trackValue ? nextValue.value : undefined,
            });
        }
        else {
            nextValues.splice(nextValues.findIndex((i) => i.value === value), 1);
        }
        onChange(nextValues);
    }, [condition, trackValue, onChange]);
    const mapValuesToItems = useCallback(() => {
        return condition.values.map(({ label: name, value: id }) => ({
            id,
            name,
        }));
    }, [condition]);
    return { handleChange, handleClear, mapValuesToItems };
}
